import { InformationAPI } from '@builddocs/data-management'
import { useQuery } from 'react-query'

type SEVERITY = 'INFO' | 'WARN' | 'ALARM'

type Banner = {
  title: string
  content: string
  severity: SEVERITY
  icon: string
}

export function useGetMyNotifications({ projectId }: { projectId?: string }) {
  return useQuery({
    queryFn: () =>
      InformationAPI.get<Array<Banner>>('/banners/my', {
        params: { projectId: projectId ? projectId : undefined },
      }).then(r => r.data),
    queryKey: ['information-service', 'banners', 'my', { projectId }],
    staleTime: Infinity,
    refetchInterval: 1000 * 60,
  })
}
